import {FetchDefaultRegistryProjectsQuery} from '../../../../generated/graphql';
import {
  checkRegistryProject,
  DEFAULT_REGISTRY_PROJECT_TYPES,
  getGlobalRegistryType,
  globalRegistryType,
} from '../../common/utils';

export function getRegistryProjectsFromQuery(
  orgName: string,
  data?: FetchDefaultRegistryProjectsQuery
) {
  const projects = data?.organization?.orgEntity?.projects?.edges;
  const entityName = data?.organization?.orgEntity?.name ?? '';
  const orgId = data?.organization?.id ?? '';

  const registries = new Map<string, globalRegistryType>();
  if (projects) {
    projects.forEach(value => {
      const projectName = value.node?.name ?? '';
      const {registryName} = checkRegistryProject(projectName);
      if (registryName != null) {
        const registryProject = value.node;
        if (registryProject == null) {
          return;
        }
        const registry = getGlobalRegistryType(
          registryProject,
          registryName,
          entityName,
          orgId,
          orgName
        );
        registries.set(registryName, registry);
      }
    });
  }
  return {registries};
}

export function getCustomRegistriesFromRegistriesMap(
  registries: Map<string, globalRegistryType>
) {
  return Array.from(registries.values()).filter(
    registry => !DEFAULT_REGISTRY_PROJECT_TYPES.includes(registry.registryName)
  );
}
